import React, { useState } from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import { CircularProgress, FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import ModalInfo from "views/Checkout/Modais/ModalInfo";
import InputMask from 'react-input-mask';
import { Autocomplete, TextField, FormControl } from "@mui/material";
import { useCadastroMultaNaoAcompanhadaStore } from "stores/cadastroMultaNaoAcompanhadaStore";
import { FormMultaNaoAcompanhadaButtons } from "../FormMultaNaoAcompanhadaButtons";
import api from "services/api";
import { serverApi } from "services/constante";

const faseOptions = [
  { label: "Defesa Prévia", value: "P" },
  { label: "1ª Instância", value: "I" },
  { label: "2ª Instância", value: "II" }
];

export function FormMultaNaoAcompanhadaParaQuem({ isActive, onFinalSubmit }) {
  const [isPending, setIsPending] = useState(false);
  const cadastroStore = useCadastroMultaNaoAcompanhadaStore();

  const fetchUser = async () => {
    const response = await api.get(serverApi.url + serverApi.versao + '/Usuario/Perfil');
    const user = response.data;
    return user;
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsPending(true);
      const formData = new FormData(e.currentTarget);
      const paraQuem = formData.get("para_quem");

      if (paraQuem == null) {
        return;
      }

      if (paraQuem === "para_outro") {
        cadastroStore.resetDadosBasicos();
        cadastroStore.goToNext();
        return;
      }

      const user = await fetchUser();

      let enderecoRua = user.Endereco;
      if (user.Numero != null) {
        enderecoRua += ` Nº ${user.Numero}`;
      }

      let cepRua = "";
      if (user.Cep != null) {
        cepRua = ` CEP: ${user.Cep}`;
      }

      const enderecoPartes = [
        enderecoRua,
        user.Complemento,
        user.Bairro,
        user.Cidade,
        user.UF,
        cepRua,
      ];

      const enderecoCompleto = enderecoPartes
        .filter(part => typeof part === "string" && part.trim().length > 0)
        .join(", ");

      const values = {
        sexo: user.Sexo,
        nomeCompletoDefesa: user.Nome,
        cpfDefesa: user.Cpf,
        telefoneContato: user.Telefone,
        enderecoCompletos: enderecoCompleto,
        cep: user.Cep,
      };

      cadastroStore.setDadosBasicos(values);
      cadastroStore.goToNext()
    } catch (e) {
      console.error(e);
    } finally {
      setIsPending(false);
    }
  };

  if (isPending) {
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <form onSubmit={onSubmit}>
      <GridContainer>
        <GridItem md={3}></GridItem>
        <GridItem xs={12} sm={12} md={6} >
          <ModalInfo label="A multa está no seu nome ou no de outra pessoa?" />
          <FormControl component="fieldset">
            <RadioGroup name="para_quem">
              <FormControlLabel
                value="para_mim"
                control={<Radio color="primary" />}
                label="A multa está no meu nome"
                style={{ color: "black" }}
              />
              <FormControlLabel
                value="para_outro"
                control={<Radio color="primary" />}
                label="A multa está no nome de outra pessoa"
                style={{ color: "black" }}
              />
            </RadioGroup>
          </FormControl>
        </GridItem>
      </GridContainer>

      <FormMultaNaoAcompanhadaButtons />
    </form>
  );
}